import React from 'react';
import { Check, Star, Cloud, Sun } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-gradient-to-b from-orange-50 via-yellow-50 to-white py-12 md:py-20 px-4 overflow-hidden" data-id="element-133">
      {/* Decorative Doodles */}
      <div className="absolute top-10 left-10 text-yellow-400 opacity-40 animate-float hidden md:block" data-id="element-134">
        <Sun size={64} data-id="element-135" />
      </div>
      <div className="absolute top-20 right-20 text-blue-300 opacity-40 animate-float hidden md:block" style={{
      animationDelay: '1s'
    }} data-id="element-136">
        <Cloud size={64} data-id="element-137" />
      </div>
      <div className="absolute bottom-20 left-20 text-pink-300 opacity-30 animate-float hidden md:block" style={{
      animationDelay: '2s'
    }} data-id="element-138">
        <Star size={48} fill="currentColor" data-id="element-139" />
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-140">
        {/* Pre-headline Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-block bg-white border-2 border-orange-200 rounded-full px-4 py-1 mb-6 shadow-sm" data-id="element-141">
          <p className="text-orange-600 font-bold uppercase tracking-wider text-xs md:text-sm flex items-center gap-2" data-id="element-142">
            <Star className="w-4 h-4 fill-orange-500" data-id="element-143" />
            Para niños de 3 a 12 años
            <Star className="w-4 h-4 fill-orange-500" data-id="element-144" />
          </p>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-6xl lg:text-7xl font-black text-gray-800 leading-tight mb-6 drop-shadow-sm" data-id="element-145">
          ¡Mantén a tus hijos{' '}
          <span className="relative inline-block text-orange-600" data-id="element-146">
            lejos de las pantallas
            <svg className="absolute w-full h-3 -bottom-1 left-0 text-yellow-300 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-147">
              <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" data-id="element-148" />
            </svg>
          </span>{' '}
          mientras aprenden y se divierten!
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-xl md:text-2xl font-medium text-gray-600 mb-10 max-w-3xl mx-auto" data-id="element-149">
          +500 Actividades educativas para potenciar su creatividad, lógica y
          desarrollo sin usar tecnología.
        </motion.p>

        {/* Main Product Image - Uploaded Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="cursor-pointer hover:scale-105 transition-transform duration-300 mb-12 max-w-4xl mx-auto relative group" onClick={scrollToPurchase} data-id="element-150">
          <div className="absolute inset-0 bg-orange-200 rounded-3xl rotate-2 transform scale-105 opacity-50 group-hover:rotate-3 transition-transform" data-id="element-151"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2ZfmDNzdAY4fuRotLASzRd/ChatGPT_Image_10_feb_2026,_23_51_27.png" alt="Mega Pack Anti-Pantallas Completo" className="relative w-full h-auto drop-shadow-2xl rounded-2xl border-4 border-white" data-id="element-152" />

          {/* Floating Badge on Image */}
          <div className="absolute -bottom-6 -right-6 bg-yellow-400 text-red-700 font-black text-lg md:text-xl p-4 rounded-full shadow-lg rotate-12 border-4 border-white hidden md:block" data-id="element-153">
            ¡OFERTA HOY!
          </div>
        </motion.div>

        {/* Feature Pills */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-10" data-id="element-154">
          {['100% Descargable', 'Listo para Imprimir', 'Sin Pantallas', 'Educativo y Divertido'].map((feature, i) => <div key={i} className="bg-white px-4 py-2 rounded-full shadow-md border border-orange-100 flex items-center gap-2 text-gray-700 font-bold text-sm md:text-base" data-id="element-155">
              <div className="bg-green-100 p-1 rounded-full" data-id="element-156">
                <Check className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-157" />
              </div>
              {feature}
            </div>)}
        </div>

        {/* CTA */}
        <CTAButton subtext="¡Descarga Inmediata y Acceso de Por Vida!" data-id="element-158" />
      </div>

      {/* Wave Divider at Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-159">
        <svg className="relative block w-[calc(100%+1.3px)] h-[50px] md:h-[80px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-160">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-161"></path>
        </svg>
      </div>
    </section>;
}